import { store } from 'store/store';
import { addNotificationAction } from 'store/notifications/notificationsActions';
import { removeFromDossier } from 'services/dossier';
import { ratingTypes } from 'shared/constants/ratingTypes';

export const removeItemsFromPortfolio = ({
  dossierId,
  dossierItemsIds,
  ratingType = ratingTypes.CREDIT_RATING,
  selectAll = false,
}) => {
  return removeFromDossier({ dossierId, dossierItemsIds, ratingType, selectAll })
    .then(response => {
      store.dispatch(
        addNotificationAction({
          message: 'Item(s) removed successfully',
          variant: 'success',
        }),
      );
      return response;
    })
    .catch(error => {
      store.dispatch(
        addNotificationAction({
          message: 'Failed to remove item from dossier',
          variant: 'error',
        }),
      );
      return Promise.reject(error);
    });
};
